module.exports = __webpack_public_path__ + "img/photo-0144.2cef4e4e.jpg";